// authRoutes - S48.4.
// Array de elementos <Route> publicos (sin auth) para el flujo de
// recuperacion de contrasena. Se monta en AppRoutes.jsx via spread:
//   <Routes>
//     <Route path="/login" .../>
//     {authRoutes}
//     <Route path="/*" element={<ProtectedRoute>...} />
//   </Routes>
// Mantener exportacion como ARRAY (no componente) garantiza que los
// <Route> sean hijos directos del <Routes> padre, requisito de React
// Router v6.
import { Route } from 'react-router-dom';
import ForgotPasswordPage from '../pages/auth/ForgotPasswordPage';
import ResetPasswordPage from '../pages/auth/ResetPasswordPage';

const authRoutes = [
  <Route key="forgot-password" path="/forgot-password" element={<ForgotPasswordPage />} />,
  <Route key="reset-password" path="/reset-password" element={<ResetPasswordPage />} />,
];

export default authRoutes;
